import { useState } from 'react';
import './Contact.scss';

function Contact() {
    const phoneInput = (e) => {
        let text = e.target.value.replace(/\D/g, '');
        
        if (text.length > 11) {
            text = text.slice(0, 11);
        }

        if (text.length > 10) {
            text = text.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
        } else if (text.length > 6) {
            text = text.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
        } else if (text.length > 2) {
            text = text.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
        } else {
            text = text.replace(/^(\d*)/, '($1');
        }

        e.target.value = text;

        handleChange(e);
    }

    function openQuestion(e) {
        const titleContent = document.querySelectorAll(".title_content");
        const faqContents = document.querySelectorAll(".faq_content");

        faqContents.forEach(function(faq) {
            faq.classList.remove("opened");
        })

        titleContent.forEach(function(title) {
            title.classList.remove("opened");
        })

        e.target.classList.add("opened");
        e.target.nextElementSibling.classList.add("opened");
    }

    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        company: "",
        subject: "",
        message: "",
    });

    const [blockForm, setBlockForm] = useState(true);

    const handleChange = (e) => {
        setForm({
        ...form,
        [e.target.name]: e.target.value
        });

        let isFilled = true;

        Object.keys(form).map(item => {
            const el = document.getElementById(item)

            if (el != null) {
                if (el.value !== "") {
                    el.classList.remove("error");
                    document.getElementById(`${item}-error`).classList.remove("visible");
                }

                if (item == 'email' && el.value.trim() !== "") {
                    if (el.value.includes('@')) {          
                        document.getElementById(`${item}-error`).classList.remove("visible");
                    } else {
                        document.getElementById(`${item}-error`).classList.add("visible");
                        document.getElementById(`${item}-error`).innerHTML = `O ${el.getAttribute('errorlabel')} é inválido`;
                    }
                }
            }
        })

        if (isFilled == true) {
            document.getElementById("submit-error").classList.remove("visible");
        } else {
            document.getElementById("submit-error").classList.add("visible");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let isFilled = true;
        let isValid = true;
        
        Object.keys(form).map(item => {
            const el = document.getElementById(item)

            if (el != null) {
                if (el.value == "") {
                    isFilled = false;
                    el.classList.add("error");
                    document.getElementById(`${item}-error`).classList.add("visible");
                    document.getElementById(`${item}-error`).innerHTML = `O ${el.getAttribute('errorlabel')} é obrigatório`;
                } else {
                    el.classList.remove("error");
                    document.getElementById(`${item}-error`).classList.remove("visible");
                }

                if (item == 'email' && el.value.trim() !== "") {
                    if (el.value.includes('@')) {                    
                        document.getElementById(`${item}-error`).classList.remove("visible");
                    } else {
                        isValid = false;
                        document.getElementById(`${item}-error`).classList.add("visible");
                        document.getElementById(`${item}-error`).innerHTML = `O ${el.getAttribute('errorlabel')} é inválido`;
                    }
                }
            }
        })

        if (isFilled == true && isValid == true) {
            document.getElementById('loading').classList.add("visible");
            document.getElementById('form').classList.add("onSend");
            let send = false;

            try {
                const response = await fetch("https://www.encodebytes.com.br/send.php", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(form)
                });

                if (response.ok) {
                    send = true;
                }
            } catch (error) {
                console.log(error);
            }

            if (send == true) {
                document.getElementById("submit-error").classList.remove("visible");
                document.getElementById("success-message").classList.add("visible");
            } else {
                document.getElementById("submit-error").classList.remove("visible");
                document.getElementById("error-message").classList.add("visible");
            }
        } else {
            document.getElementById("submit-error").classList.add("visible");
        }
    };


    return (
        <section className="contact" id="contato">
            <div className="container">
                <div className="contact__wrapper">
                    <h4 className="title"><span>Contato</span>Pronto para sair da caixa?</h4>

                    <div className="contact__wrapper__boxes">
                        <div className="contact__wrapper__boxes__left">
                            <p className="contact__wrapper__boxes__title">Dúvidas frequentes</p>

                            <ul className="contact__wrapper__boxes__left__faq">
                                <li className="contact__wrapper__boxes__left__faq__question">
                                    <p className="contact__wrapper__boxes__left__faq__question__title title_content" onClick={(e) => openQuestion(e)}>01. Minha empresa é pequena, realmente preciso de um site?</p>
                                    <p className="contact__wrapper__boxes__left__faq__question__content faq_content">
                                        Sim, mesmo os pequenos negócios precisam de credibilidade, posicionamento e presença digital profissional.
                                    </p>
                                </li>

                                <li className="contact__wrapper__boxes__left__faq__question">
                                    <p className="contact__wrapper__boxes__left__faq__question__title title_content" onClick={(e) => openQuestion(e)}>02. E se eu já tenho Instagram?</p>
                                    <p className="contact__wrapper__boxes__left__faq__question__content faq_content">
                                        O Instagram é uma ótima ferramenta, mas não substitui um site. O site é o seu espaço próprio, sem depender de algoritmo.
                                    </p>
                                </li>

                                <li className="contact__wrapper__boxes__left__faq__question">
                                    <p className="contact__wrapper__boxes__left__faq__question__title title_content" onClick={(e) => openQuestion(e)}>03. Quanto tempo leva para o site ficar pronto?</p>
                                    <p className="contact__wrapper__boxes__left__faq__question__content faq_content">
                                        Em média:
                                        <br/>
                                        <br/>
                                        Landing page: 7 a 10 dias.
                                        <br/>
                                        <br/>
                                        Site institucional: 10 a 20 dias.
                                        <br/>
                                        <br/>
                                        (Podendo variar conforme complexidade do projeto e envio de materiais pelo cliente)
                                    </p>
                                </li>

                                
                                <li className="contact__wrapper__boxes__left__faq__question">
                                    <p className="contact__wrapper__boxes__left__faq__question__title title_content" onClick={(e) => openQuestion(e)}>04. Eu já preciso ter domínio ou hospedagem?</p>
                                    <p className="contact__wrapper__boxes__left__faq__question__content faq_content">
                                        Não, nós orientamos e auxiliamos em todo o processo de registro de domínio e hospedagem.
                                    </p>
                                </li>

                                <li className="contact__wrapper__boxes__left__faq__question">
                                    <p className="contact__wrapper__boxes__left__faq__question__title title_content" onClick={(e) => openQuestion(e)}>05. Meu site vai funcionar no celular?</p>
                                    <p className="contact__wrapper__boxes__left__faq__question__content faq_content">
                                        Sim, todos os nossos projetos são responsivos e adaptados para todos os tamanhos de telas, com foco nos celulares onde é feito a maior parte do tráfego pelos usuários.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="contact__wrapper__boxes__right">
                            <p className="contact__wrapper__boxes__title">Nos envie uma mensagem</p>

                            <div className="contact__wrapper__boxes__right__form">
                                
                                <form onSubmit={handleSubmit} onInput={handleChange} onClick={handleChange} noValidate id="form">
                                    <div className="doubleField">
                                        <div className="row">
                                            <label htmlFor="name" className="required">Nome</label>
                                            <input type="text" name="name" id="name" errorlabel="nome" required onChange={handleChange} />
                                            <span id="name-error" className="form-error"/>
                                        </div>

                                        <div className="row">
                                            <label htmlFor="company" className="required">Empresa</label>
                                            <input type="text" id="company" name="company" errorlabel="empresa" required onChange={handleChange} />
                                            <span id="company-error" className="form-error"/>
                                        </div>
                                    </div>

                                    <div className="doubleField">       
                                        <div className="row">
                                            <label htmlFor="email" className="required">E-mail</label>
                                            <input type="email" name="email" id="email" required errorlabel="e-mail" onChange={handleChange} />
                                            <span id="email-error" className="form-error"/>
                                        </div>

                                        <div className="row">
                                            <label htmlFor="phone" className="required">Celular</label>
                                            <input type="tel" name="phone" id="phone" required errorlabel="celular" onChange={phoneInput} />
                                            <span id="phone-error" className="form-error"/>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <label htmlFor="subject" className="required">Assunto</label>
                                        <select id="subject" required name="subject" errorlabel="assunto" onChange={handleChange}>
                                            <option disabled selected value="">Selecione um assunto</option>
                                            <option value="Orçamento">Orçamento</option>
                                            <option value="Dúvida">Dúvida</option>
                                            <option value="Elogio">Elogio</option>
                                            <option value="Reclamação">Reclamação</option>
                                        </select>
                                        <span id="subject-error" className="form-error"/>
                                    </div>

                                    <div className="row">
                                        <label htmlFor="message" className="required">Mensagem</label>
                                        <textarea id="message" required name="message" errorlabel="mensagem" onChange={handleChange} />
                                        <span id="message-error" className="form-error"/>
                                    </div>

                                    <button id="submitButton" type="submit" className="cta v3">Enviar</button>
                                    <span id="submit-error" className="form-error v2">É necessário preencher todos os campos.</span>

                                    <div id="loading">
                                        <div className="circle"></div>
                                    </div>

                                    <p className="warning-text">Os campos marcados com <span>*</span> (asterisco) são obrigatórios.</p>
                                </form>

                                <div className="contact__wrapper__boxes__right__message" id="success-message">
                                    <p>Formulário enviado com sucesso!</p>
                                    <span>Agradecemos o contato, entraremos em contato o mais breve possível via email ou WhatsApp.</span>
                                </div>

                                <div className="contact__wrapper__boxes__right__message error" id="error-message">
                                    <p>Ops!</p>
                                    <span>Houve algum erro ao tentar enviar a sua mensagem. Por favor, tente novamente.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )    
}

export default Contact;